function Equlize_Height(list,elments,callback){
	this.elems = (elments) ? list : document.querySelectorAll(list);
	this.callback = (typeof callback === 'function') ?  callback : null;
	this.methods = {
		it: this,
		make : function(){
			
			var elems = this.elems;
			var il = elems.length;
			var callback = this.callback;
			
			function equalize(){
				var max_height = -1;
				for(var i = 0; i < il; i++){
					elems[i].style.height = "";
				}
				for(var i = 0; i < il; i++){
					max_height = (max_height < elems[i].offsetHeight) ? elems[i].offsetHeight : max_height;
				}
				
				for(var i2 = 0; i2 < il; i2++){
					elems[i2].style.height = max_height + 'px';
				}
				if(callback) callback(max_height,elems);
			}

			window.addEventListener('resize',equalize);
			document.readyState !== 'loading' ? setTimeout(equalize,200) : window.addEventListener('load',function(){setTimeout(equalize,200)});
		}.bind(this)
	};
	this.init = (function(){
		for(var key in this.methods){
			if(typeof this.methods[key] === "function"){
				this.methods[key]();
			}
		}
	}.bind(this))();
}
window.align_height = function(args){
	var titles = (typeof args.selector !== 'string') ? args.selector : document.querySelectorAll(args.selector);
	if(!titles.length) return;
	var tl = titles.length,
		inc = 0,
		collection = [],
		vps = args.viewports,
		by = args.by,
		allow = [],
		methods = Object.create(lib);
	methods.distribute = function(by){
		collection = [];
		inc = 0;
		for(var i = 0; i < tl; i++){
			if(i % by === 0){
				var part = [];
				for(var j = inc; j < inc+by; j++){
					if(titles[j]) part.push(titles[j]);
				}
				collection.push(part);
				inc+=by;
			}
		}
	};
	methods.all_allow_items_true = function(){
		allow = [];
		vps.forEach(function(item){
			allow.push(true);
		});
	};
	methods.equalize = function(items){
		items.forEach(function(nested){
			var nested_eq = new Equlize_Height(nested, true,args.callback);
		});
	};
	methods.all_allow_items_true();
	function make(){
		for(var i = 0; i < vps.length; i++){
			if(methods.viewport().width < (vps[i]) && methods.viewport().width >= (vps[i+1] || 0) ){
				if(allow[i]){
					methods.distribute(by[i] || 4);
					methods.equalize(collection);
					methods.all_allow_items_true();
					allow[i] = false;
				}
			}
		}
	}
	make();
	window.addEventListener('load',make);
	window.addEventListener('resize',make);
}



// WEBPACK FOOTER //
// ./assets/js/box-height.js